import _ from 'lodash';
import { createSelector } from 'reselect';
import timm from 'timm';

import millieApi    from 'app/apis/millie';
import reducerUtils from 'app/reducers/utils';
import EntitiesSlx  from 'app/selectors/entities';



/*
 *  Actions
 */

const Types = {
  LOAD_TOP_100: 'NONPROFITS_LOAD_TOP_100',
};

const Ax = {

  loadTop100: () => (dispatch, getState) => {
    const hasStarted = Slx.top100Started(getState());
    if (hasStarted) return;
    const promise = millieApi.nonprofitsSearch({pageSize: 100});
    return dispatch({type: Types.LOAD_TOP_100, promise, _entities: ['nonprofits']});
  },

};



/*
 *  Reducer
 */

const initialState = {
  top100Pending: false,
  top100Ids: null,
};

const reducer = reducerUtils.createReducer(initialState, {

  [`${Types.LOAD_TOP_100}_PENDING`]: (state, action) => {
    return {...state,
      top100Pending: true,
    };
  },
  [`${Types.LOAD_TOP_100}_RESOLVED`]: (state, action) => {
    const top100Ids = action.result.nonprofits.map(np => np.id);
    return {...state,
      top100Pending: false,
      top100Ids: _.shuffle(top100Ids),
    };
  },
  [`${Types.LOAD_TOP_100}_REJECTED`]: (state, action) => {
    return {...state,
      top100Pending: false,
    };
  },

});



/*
 *  Selectors
 */

const Slx = (() => {

  const selTop100Pending = state => state.nonprofits.top100Pending;
  const selTop100Ids     = state => state.nonprofits.top100Ids;

  const selTop100Started = createSelector(
    [selTop100Pending, selTop100Ids],
    (isPending, ids) => {
      return !!(isPending || ids);
    }
  );

  return {
    top100Started: selTop100Started,
    top100Ids: selTop100Ids,
  };

})();



export {Types, Ax, reducer, Slx};
export default {Types, Ax, reducer, Slx};
